import { isNull } from 'lodash-es'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

import { TRoomId, TRoomPosition } from '@/entities/room/@x/map'

export type Room = {
  id: TRoomId
  position: TRoomPosition
}

type ViewingRoomAction = {
  updateViewingRoom: (room: Room) => void
  resetViewingRoom: () => void
}

type ViewingRoomState = {
  viewingRoom: Room | null
  isViewing: (roomId: number) => boolean
  actions: ViewingRoomAction
}

export const useViewingRoomStore = create<ViewingRoomState>()(
  subscribeWithSelector((set, get) => ({
    viewingRoom: null,
    isViewing: (roomId: number) => {
      const { viewingRoom } = get()

      return !isNull(viewingRoom) && viewingRoom.id === roomId
    },
    actions: {
      updateViewingRoom: room => {
        set({ viewingRoom: room })
      },
      resetViewingRoom: () => {
        set({ viewingRoom: null })
      },
    },
  })),
)
